<h4>{{ 'orderCost.orderSummary' | cxTranslate }}</h4>

<!-- spinner -->
<!-- <div *ngIf="sharedService.showSimulationLoader; else ShowSummary">
<cx-spinner></cx-spinner>
</div> -->

<!-- <ng-template #ShowSummary> -->
@if (cart) {
  <div class="cx-summary-partials">
    <!-- TODO AC-265 -->
    <!--<div class="cx-summary-row">-->
    <!--  <div class="col-6 cx-summary-label">-->
    <!--    {{-->
    <!--       'orderCost.estimatedShipping'  | cxTranslate-->
    <!--    }}-->
  <!--  </div>-->
  <!--  <div class="col-6 cx-summary-amount">-->
  <!--    {{-->
  <!--      cart.deliveryCost?.formattedValue-->
  <!--        ? cart?.baseDeliveryTime-->
  <!--        : ('orderCost.toBeDetermined' | cxTranslate)-->
  <!--    }}-->
<!--  </div>-->
<!--</div>-->
<div class="cx-summary-row">
  <div class="col-6 cx-summary-label">
    {{ 'orderCost.subtotal' | cxTranslate }}
  </div>
  <div class="col-6 cx-summary-amount">
    {{ cart.subTotal?.formattedValue }}
  </div>
</div>
@if (cart.net) {
  <div class="cx-summary-row">
    <div class="col-6 cx-summary-label">
      {{ 'orderCost.salesTax' | cxTranslate }}
    </div>
    <div class="col-6 cx-summary-amount">
      {{ cart.totalTax?.formattedValue }}
    </div>
  </div>
}
<div class="cx-summary-row cx-summary-total">
  <div class="col-6 cx-summary-label">
    {{ 'orderCost.total' | cxTranslate }}
  </div>
  <div class="col-6 cx-summary-amount">
    {{ cart.totalPriceWithTax?.formattedValue }}
  </div>
</div>
@if (cart.totalDiscounts?.value > 0) {
  <div class="cx-summary-row">
    {{ 'orderCost.discount' | cxTranslate }}
    {{ cart.totalDiscounts?.formattedValue }}
  </div>
}
@if (!cart.net) {
  <div class="cx-summary-row">
    {{ 'orderCost.grossTax' | cxTranslate }}
    {{ cart.totalTax?.formattedValue }}.
  </div>
}
</div>
}

<ng-container *cxFeatureLevel="'1.3'">
  <cx-applied-coupons [vouchers]="cart.appliedVouchers" [isReadOnly]="true"></cx-applied-coupons>
</ng-container>
<!-- </ng-template> -->
